module.exports = __webpack_public_path__ + "static/media/Earth.307f91c4.png";